// Montessori
import React from 'react';
import NatioalSpaceDay2025  from 'views/NatioalSpaceDay2025';

const Montessoripage = () => {
  return <NatioalSpaceDay2025/>;
};

export default Montessoripage;